window.onload = function () {
    
    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){

            if (typeof gtag == 'function') {
                gtag('event', 'whatsapp_burbuja');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp_burbuja');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp_burbuja' });
            };
           console.log('click in whatsapp');
         
       }
    };
    
    /**
     * Asigna una clase en base al tipo de enlace
     */
    $('a[href^=tel]').addClass("link-phone");
    $('a[href^=mailto]').addClass("link-email").attr("target", "_blank");
    $('a[href*="wa.me"]').addClass("link-whatsapp").attr("target", "_blank");
    $('a[href*="wa.link"]').addClass("link-whatsapp").attr("target", "_blank");
    $('a[href*="api.whatsapp"]').addClass("link-whatsapp").attr("target", "_blank");

    // Manejo de Eventos
    $('.link-phone').click(function () {
        if (typeof gtag == 'function') {
            gtag('event', 'telefono_llamada' );
        };
        if (typeof ga == 'function') {
            ga('send', 'event', 'telefono', 'click', 'llamada');
        };
        if (typeof fbq == 'function') {
            fbq('track', 'Contact', { content_name: 'telefono' });
        };
    });

    $('.link-email').click(function () {
        if (typeof gtag == 'function') {
            gtag('event', 'email_envio' );
        }
        if (typeof ga == 'function') {
            ga('send', 'event', 'email', 'click', 'envio');
        };
        if (typeof fbq == 'function') {
            fbq('track', 'Contact', { content_name: 'email' });
        };
    });

    $('.link-whatsapp').click(function () {
        if (typeof gtag == 'function') {
            gtag('event', 'whatsapp' );
        }
        if (typeof ga == 'function') {
            ga('send', 'event', 'telefono', 'click', 'whatsapp');
        };
        if (typeof fbq == 'function') {
            fbq('track', 'Contact', { content_name: 'whatsapp' });
        };
    });
    
}